import Component from '../core/Component';
import throttle from 'lodash/throttle';
import enquire from 'enquire.js'
import { queries } from '../core/config'

export default class Horizontal extends Component {
    constructor(element) {
        super(element);

        this.handleScroll = throttle(::this.scroll)
        // this.handleMobileScroll = throttle(::this.mobileScroll)
        this.handleResize = throttle(::this.resize)

        this.ref = {
            container: null,
            decorations: [],
            numbers: null
        }

        this.enquireHandlers = {
            desktop: {
                match: () => {
                    this.sizer = document.createElement('div')
                    this.sizer.style.height = this.ref.container.offsetWidth + "px"
                    this.sizer.style.width = "1px"
                    this.sizer.style.position = "absolute"
                    this.sizer.style.top = "0px"
                    this.element.appendChild(this.sizer)
                    window.addEventListener('scroll', this.handleScroll)
                    this.handleResize()
                    this.handleScroll()
                    window.addEventListener('resize', this.handleResize)
                },
                unmatch: () => {
                    if (this.sizer) {
                        this.element.removeChild(this.sizer)
                        this.sizer = null
                    }
                    window.removeEventListener('scroll', this.handleScroll)
                    window.removeEventListener('resize', this.handleResize)
                    this.clear()
                }
            },
            /* tablet: {
                match: () => {
                    this.element.addEventListener('scroll', this.handleMobileScroll)
                    this.handleResize()
                    this.handleMobileScroll()
                },
                unmatch: () => {
                    this.element.removeEventListener('scroll', this.handleMobileScroll)
                }
            } */
        }

        this.footer = document.getElementById('footer').querySelector('.Footer')
    }

    prepare() {
        this.width = this.ref.container.offsetWidth - this.element.offsetWidth;
        this.footerWidth = this.footer.offsetWidth

        this.ref.decorations.forEach(item => {
            item.multiplier = JSON.parse(item.dataset.multiplier);
        });

        enquire.register(queries.largeUp, this.enquireHandlers.desktop)
        // enquire.register(queries.mediumMax, this.enquireHandlers.tablet)
    }

    destroy() {
        enquire.unregister(queries.largeUp, this.enquireHandlers.desktop)
        // enquire.unregister(queries.mediumMax, this.enquireHandlers.tablet)
        window.removeEventListener('resize', this.handleResize)
        window.removeEventListener('scroll', this.handleScroll)
    }

    resize(event) {
        var body = document.body, html = document.documentElement;
        this.docHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
        this.width = this.ref.container.offsetWidth - window.innerWidth;
        this.footerWidth = this.footer.offsetWidth
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        this.height = this.docHeight - this.element.offsetHeight;
        this.mobileWidth = this.ref.container.offsetWidth - this.windowWidth;


        if (this.sizer) {
            const height = this.ref.container.offsetWidth + this.footer.offsetWidth - (this.windowWidth - this.windowHeight) + 81
            this.sizer.style.height = `${height}px`
        }

        this.scroll();
    }

    scroll(event) {
        const offset = window.pageYOffset
        let percent = Math.round(window.pageYOffset/this.height*1000)/10;

        // move decorations
        this.ref.decorations.forEach(item => {
            let x = percent*item.multiplier.x;
            let y = percent*item.multiplier.y;
            let r = percent*item.multiplier.r;
            item.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${r}deg)`;
        });

        // set scroll
        this.ref.container.style.transform = `translate3d(${-1*offset}px, 0px, 0)`;
        this.ref.numbers.style.transform = `translate3d(${offset}px, -50%, 0)`;
    }

    clear() {
        this.ref.container.style.transform = null
        this.ref.numbers.style.transform = null
        this.ref.decorations.forEach(item => {
            item.style.transform = null
        })
    }


    /* mobileScroll(event) {
        const offset = this.element.scrollLeft
        let percent = Math.round(this.element.scrollLeft/this.mobileWidth*1000)/10;
        //console.log(percent)

        // move decorations
        this.ref.decorations.forEach(item => {
            let x = percent*item.multiplier.x;
            let y = percent*item.multiplier.y;
            let r = percent*item.multiplier.r;
            item.style.transform = `translate3d(${x*.3}px, ${y*.3}px, 0) rotate(${r*.3}deg)`;
        });
    } */
}


// WEBPACK FOOTER //
// ./components/Horizontal.js